module.exports = __webpack_public_path__ + "static/logosheet-1440-289f8dfe6bd4905865c177a97935568d.jpg";